import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconOnboarding(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M20.12 8.89c.8-.21 1.62.26 1.84 1.06.21.8-.27 1.62-1.07 1.84L5.07 16.03c-.43.11-.89-.08-1.12-.47l-1.88-3.25a.492.492 0 0 1 .3-.73l.33-.09c.31-.08.63-.01.88.18l1.57 1.24 4.97-1.33-3.44-5.96c-.35-.61-.03-1.39.65-1.58.36-.1.75-.01 1.02.25l6.46 6.02 5.31-1.42ZM3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
